import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { TableBtn } from 'src/app/shared/interfaces/table-btn';
import { TableColumn } from 'src/app/shared/interfaces/table-column';
import { UserService } from 'src/app/_services';
import { ExportCSVService } from 'src/app/_services/export-csv.service';
import { SnackbarService } from 'src/app/_service/message-service';
import { GeneralDialogComponent } from 'src/app/shared/components/general-dialog/general-dialog.component';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { Permission } from 'src/app/util/enums/permission.enum';
import { UserInfoService } from 'src/app/_services/userInfo.service';
import { AuthenticationService } from 'src/app/_services';
import { BreadcrumbService } from '../breadcrumb/breadcrumb.service';
import { RouteConstants } from 'src/app/util/route.constants';

declare var $: any;
export interface walletData {
  userName: string;
  email: string;
  mobile: number;
  createdDate: string;
  time: string;
  city: string;
  country: string;
  amount: number;
  walletId: number;
  userId: number;
  countryCode: string;

}
export interface TransactionData {
  tnxId: number;
  orderId: string;
  paymentId: string;
  paymentDate: string;
  operation: string;
  description: string;
  amount: number;
  userId: string;
  gatewayName: string;
}
@Component({
  selector: 'telio-wallets',
  templateUrl: './wallets.component.html',
  styleUrls: ['./wallets.component.scss']
})
export class WalletsComponent implements OnInit, OnDestroy {

  subscription: Subscription = new Subscription;
  @ViewChild('callOtpDialog', { static: false }) callOtpDialog: TemplateRef<any>;
  @ViewChild('transactionDialog', { static: false }) transactionDialog: TemplateRef<any>;
  otpForm: UntypedFormGroup;
  walletList: walletData[];
  initialWalletData: any;
  columns: TableColumn[];
  tcolumns: TableColumn[];
  buttons: TableBtn[];
  tbuttons: TableBtn[];
  actionHeader: string = '';
  actionHeaderWallet = '';
  filterPlaceholder: string = '';
  walletTransactionList: any;
  walletId;
  userId;
  amount;
  mobile;
  countryCode;
  transUserId;
  pageList = {
    currentPage: 0,
    pageSize: 10
  };
  currentPage = 0;
  totalDataCount = 0;
  totalDataCountId = 0;
  sortColumn = '';
  sortDirection = 'asc';
  mobileRegEx: RegExp = /^\d{9}(\d{1})?$/;
  amountRegEx: RegExp = /^\d+(\.\d{1,2})?$/;
  initialWalletPopUpData: any;

  constructor(private userservice: UserService,
    private router: Router,
    public dialog: MatDialog,
    private toastr: SnackbarService,
    private formBuilder: UntypedFormBuilder,
    private userInfoService: UserInfoService,
    readonly route: ActivatedRoute,
    readonly translate: TranslateService, readonly exportCSVService: ExportCSVService, private authenticationService: AuthenticationService,
    readonly breadcrumbService: BreadcrumbService) {
    this.rerender(this.pageList, '');
  }

  ngOnInit(): void {
    this.columns = [
      { columnDef: 'username', header: 'wallets.userName', cell: (element: walletData) => `${element.userName}`, sortingDisabled: false, caseSensitive: 'capitalize', isLink: this.userInfoService.filterPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.READ), width: '110px' },
      { columnDef: 'email', header: 'wallets.email', cell: (element: walletData) => `${element.email}`, sortingDisabled: false, width: '190px' },
      { columnDef: 'mobile', header: 'wallets.contact', cell: (element: walletData) => `${element.mobile}`, sortingDisabled: false, width: '120px' },
      { columnDef: 'created_date', header: 'wallets.date', cell: (element: walletData) => `${element.createdDate}`, sortingDisabled: false, width: '120px' },
      { columnDef: 'amount', header: 'transactions.balance', cell: (element: walletData) => `${element.amount}`, sortingDisabled: false, isCurrency: true, align: 'right', headerAlign: true, width: '90px' }
    ];

    this.tcolumns = [
      { columnDef: 'tnx_id', header: 'wallets.paymentTransId', cell: (element: TransactionData) => `${element.tnxId}`, sortingDisabled: false, width: '137px', align: 'center' },
      { columnDef: 'order_id', header: 'wallets.orderId', cell: (element: TransactionData) => `${element.orderId}`, sortingDisabled: true, width: '80px' },
      { columnDef: 'payment_id', header: 'wallets.paymentGatewayId', cell: (element: TransactionData) => `${element.paymentId}`, sortingDisabled: true, width: '123px' },
      { columnDef: 'payment_date', header: 'wallets.paymentDate', cell: (element: TransactionData) => `${element.paymentDate}`, sortingDisabled: true, width: '80px' },
      { columnDef: 'operation', header: 'wallets.operation', cell: (element: TransactionData) => `${element.operation}`, sortingDisabled: true, width: '80px', caseSensitive: 'capitalize' },
      { columnDef: 'gatewayName', header: 'wallets.paymentGateway', cell: (element: TransactionData) => `${element.gatewayName}`, sortingDisabled: true, width: '120px', caseSensitive: 'capitalize' },
      { columnDef: 'description', header: 'wallets.description', cell: (element: TransactionData) => `${element.description}`, sortingDisabled: true, width: '120px', caseSensitive: 'capitalize' },
      { columnDef: 'amount', header: 'wallets.amountWithCurrency', cell: (element: TransactionData) => `${element.amount}`, sortingDisabled: true, isCurrency: true, width: '90px', align: 'right', headerAlign: true },
    ];

    this.buttons = [
      { styleClass: 'submit', icon: 'edit', payload: (element: walletData) => `${[element.userId, element.userName]}`, action: 'edit', tooltip: 'wallets.edit', enable: this.checkPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.UPDATE) },
    ];

    this.tbuttons = [
      { styleClass: 'submit', icon: 'assignment_return', payload: (element: TransactionData) => `${element.amount},${element.paymentId},${element.orderId},${element.operation},${element.gatewayName}`, action: 'refund', tooltip: 'wallets.requestRefund', isDisabled: (element: TransactionData) => `${element.orderId == 'NA' || element.paymentId == 'NA'}`, enable: this.checkPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.UPDATE) },
    ]

    this.actionHeader = 'wallets.actions';
    this.actionHeaderWallet = 'wallets.adjustment';
    this.filterPlaceholder = 'generalTable.filterPlaceholder';
    this.otpForm = this.formBuilder.group({
      mobile: [{
        value: null,
        disabled: true
      }, Validators.compose([
        Validators.required,
        Validators.pattern(this.mobileRegEx)
      ])],
      countryCode: [{
        value: null, disabled: true
      }],
      amount: [null, Validators.compose([
        Validators.required,
        Validators.pattern(this.amountRegEx)
      ])]
    })
  }

  resetForm() {
    this.otpForm.reset()
  }

  dateTransform(date: string) {
    let dateIn: Date = new Date(date);
    let dateOut = dateIn.toISOString().replace("T", " ").substring(0, 19);
    return dateOut;
  }

  getAllWallets(value, searchFilter) {
    this.subscription.add(this.userservice.getAllWallets(value.currentPage + 1, value.pageSize, this.sortColumn, this.sortDirection, searchFilter).subscribe((resp: any) => {
      if (!!resp) {
        this.walletList = resp.content;
        this.totalDataCount = resp.total_items;
        this.setAllWalletsMap(this.walletList)
      }
      else {
        this.walletList = []
      }
    },
      error => {
        this.walletList = [];
      }))
  }

  actionCSV() {
    const options = {
      filename: this.translate.instant('wallets.wallets'),
      showTitle: false,
      title: this.translate.instant('wallets.wallet'),
      useKeysAsHeaders: true,
    }
    this.subscription.add(this.userservice.getAllWallets(1, this.totalDataCount, this.sortColumn, 'asc', '').subscribe(
      (resp: any) => {
        this.initialWalletData = resp.content
        this.setAllWalletsMap(this.initialWalletData)
        this.initialWalletData = this.initialWalletData.map((item: any) => {
          delete item.wallet_id;
          delete item.user_id;
          delete item.created_date;
          delete item.user_name;
          delete item.country_code;
          delete item.mobile
          return item
        })
        this.exportCSVService.exportCSV(options, this.initialWalletData);
      }
    ))
  }

  actionCSVId() {
    let empty = 'NA';
    const options = {
      filename: this.translate.instant('wallets.transactions'),
      showTitle: false,
      title: this.translate.instant('wallets.transactions'),
      useKeysAsHeaders: true,
    };

    const transformedData = this.initialWalletPopUpData.map(item => {

      return {
        tnxId: !item.tnxId ? empty : item.tnxId,
        orderId: !item.orderId ? empty : item.orderId,
        paymentId: !item.paymentId ? empty : item.paymentId,
        paymentDate: !item.paymentDate ? empty :item.paymentDate,
        operation: !item.operation ? empty : item.operation,
        description: !item.description ? empty : item.description,
        amount: !item.amount ? empty : item.amount,
        avaliable_balance: !item.avaliable_balance ? empty : item.avaliable_balance,
        gateway_name: !item.gateway_name ? empty : item.gateway_name
      };
    });

    this.exportCSVService.exportCSV(options, transformedData);
}


  buttonClick(result: string[]) {
    switch (result[0]) {
      case 'edit':
        this.editWallet(result[1])
        break;
      case 'recharge':
        let tempArray = result[1].split(',')
        this.userId = tempArray[0]
        this.mobile = tempArray[1]
        this.countryCode = tempArray[2]
        this.openOtpDailog()
        break;
      default:
        break;
    }
  }

  tbuttonClick(result: string[]) {
    let tempArray = result[1].split(',')
    let amount = tempArray[0]
    let paymentId = tempArray[1]
    let orderId = tempArray[2]
    let operation = tempArray[3]
    let gateway = tempArray[4]
    if (operation.toLowerCase() == "pg-credit") {
      let input = {
        'orderId': orderId,
        'paymentId': paymentId,
        'amount': (+amount) * 100,
        'userId': +this.transUserId
      }
      this.subscription.add(this.userservice.requestRefund(input, gateway).subscribe((resp: any) => {
        switch (resp.statusCode) {
          case 500:
            this.toastr.error(resp.message)
            break;
          case 200:
            if (!!resp.body.refundUniqueId) {
              this.toastr.success(resp.body.status);
              return
            }
            else {
              this.toastr.error(resp.body.status)
            }
            break;
          default:
            break
        }
      },
        error => {
          this.toastr.error(error)
        }
      ))
    }
    else {
      this.toastr.error(this.translate.instant('wallets.refundNa'))
    }
  }

  openOtpDailog() {
    this.otpForm.reset()
    let dialogRef = this.dialog.open(this.callOtpDialog, {
      height: '500px',
      width: '500px'
    }).afterClosed().subscribe((res: any) => {
    })
  }

  openTransactionDailog() {
    let dialogRef = this.dialog.open(this.transactionDialog, {
      height: '550px',
      width: '1000px'
    }).afterClosed().subscribe((res: any) => {
    })
  }

  getWalletTranscationsById(id) {
    this.subscription.add(this.userservice.getWalletTransationsByWalletId(id).subscribe((resp: any) => {
      this.walletTransactionList = resp.transactions;
      this.totalDataCountId = this.walletTransactionList.length;
      this.transUserId = resp.user_id
      this.walletTransactionList.map((item: any, i: number) => {
        let empty = 'NA';
        item.tnxId = !item.tnx_id ? empty : item.tnx_id
        item.orderId = !item.order_id ? empty : item.order_id
        item.paymentId = !item.payment_id ? empty : item.payment_id
        item.paymentDate = !item.payment_date ? empty : this.authenticationService.convert24HrTo12Hr(this.authenticationService.convertToLocalTime(item.payment_date, this.userInfoService.userDetails.prefCountry));
        item.operation = !item.operation ? empty : item.operation.toLowerCase()
        item.description = !item.description ? empty : item.description.toLowerCase()
        item.amount = item.amount.toFixed(2)
        item.gatewayName = !item.gateway_name ? empty : item.gateway_name
      });
      this.initialWalletPopUpData = this.walletTransactionList
    },
      error => {
        this.walletTransactionList = [];
      }))
  }

  editWallet(result) {
    let resultArray = result.split(',')
    let objToSend: NavigationExtras = {
      queryParams: {
        "userId": resultArray[0],
        "mobileUser": resultArray[1]
      },
      skipLocationChange: true
    };
    this.router.navigate(['/dashboard/wallets/transactions', { routeID: this.route.snapshot.paramMap.get('routeID') }], objToSend);
    this.breadcrumbService.emitBreadCrumbs(RouteConstants.WALLETS_ADJUSMENT);
  }

  actionClick() {
    this.rerender(this.pageList, '');
  }

  submitOTP() {
    let input = {
      "amount": this.otpForm.value.amount,
      "currency": "RWF",
      "externalId": "1351234",
      "payer": {
        "partyIdType": "MSISDN",
        "partyId": this.countryCode + this.mobile
      },
      "payerMessage": "Pay for product a",
      "payeeNote": "Note"
    }
    this.subscription.add(this.userservice.rechargeWallet(input, this.userId, this.countryCode).subscribe((resp: any) => {
      switch (resp.statusCode) {
        case 400:
          this.toastr.error(resp.message);
          break
        case 200:
          this.toastr.success(this.translate.instant('wallets.walletSuccess'));
          this.dialog.closeAll();
          break;
      }
    },
      error => {
        this.toastr.error(error)
      }
    ))
  }

  linkClick(event: any) {
    if (event.column.columnDef == "username") {
      this.walletId = event.row.walletId;
      this.getWalletTranscationsById(this.walletId);
      this.openTransactionDailog();
    }
  }

  reuestRefund(result: string[]): void {
    let dialogRef = this.dialog.open(GeneralDialogComponent, {
      width: '50vw',
      height: '200px',
      data: { component: ConfirmDialogComponent, button: this.translate.instant('faq.confirmButton'), title: this.translate.instant('createStation.confiration'), otherbtn: this.translate.instant('faq.confirmNo'), message: this.translate.instant('wallets.refundConfirmation') }
    }).afterClosed().subscribe(res => {
      if (res && res == 'Yes') {
        this.tbuttonClick(result);
      }
    });
  }

  checkPermission(id: number, permission: string): boolean {
    return this.userInfoService.filterPermission(id, permission)
  }

  loadData(value: any) {
    let val = {
      currentPage: value.currentPage,
      pageSize: value.pageSize
    }
    this.pageList.pageSize = value.pageSize;
    this.rerender(val, '')
  }

  sortClick(event: any) {
    this.sortColumn = event.active;
    this.sortDirection = event.direction;
    this.rerender(this.pageList, '');
  }

  rerender(value: any, searchFilter?: string) {
    this.getAllWallets(value, searchFilter);
  }

  applyFilter(filteredData: string) {
    this.rerender(this.pageList, filteredData)
  }

  ngOnDestroy() {
    this.subscription && this.subscription.unsubscribe();
  }

  setAllWalletsMap(data) {
    data.map((item: any, i: number) => {
      let empty = 'NA';
      item.amount = item.amount.toFixed(2)
      item.email = !item.email ? empty : item.email
      item.walletId = item.wallet_id
      item.createdDate = !item.created_date ? empty : this.authenticationService.convert24HrTo12Hr(this.authenticationService.convertToLocalTime(item.created_date, this.userInfoService.userDetails.prefCountry)),
        item.userName = !item.user_name ? empty : item.user_name.toLowerCase()
      item.contact = !item.mobile ? empty : item.mobile
      item.city = !item.city ? empty : item.city
      item.country = !item.country ? empty : item.country
      item.userId = !item.user_id ? empty : item.user_id
      item.countryCode = !item.country_code ? empty : item.country_code
    });
  }

}